import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import messages from '../messages';
import style from '../../../../customers-page/modals/combine-customers-modal/combine-customers-modal.module.less';
import { EXPORT_ALL, EXPORT_SELECTED } from '../../constants/export-products';

const ExportTypeSelector = ({ totalRecords, selectedCount, exportType, setExportType }) => {
  const chooseExportSelected = useCallback(() => {
    setExportType(EXPORT_SELECTED);
  }, [setExportType]);
  const chooseExportAll = useCallback(() => {
    setExportType(EXPORT_ALL);
  }, [setExportType]);

  return (
    <div className={style['select-options-radio-group']}>
      <RadioCheckList>
        <RadioCheckListItem
          className={style['select-options-radio-button']}
          isChecked={exportType === EXPORT_SELECTED}
          isDisabled={selectedCount === 0}
          onChecked={chooseExportSelected}
        >
          <FormattedMessage {...messages.productExportSelectedItems} values={{ selectedProductCount: selectedCount }} />
        </RadioCheckListItem>
        <RadioCheckListItem
          className={style['select-options-radio-button']}
          isChecked={exportType === EXPORT_ALL}
          onChecked={chooseExportAll}
        >
          <FormattedMessage {...messages.productExportAllItems} values={{ productCount: totalRecords }} />
        </RadioCheckListItem>
      </RadioCheckList>
    </div>
  );
};

ExportTypeSelector.propTypes = {
  totalRecords: PropTypes.number.isRequired,
  selectedCount: PropTypes.number.isRequired,
  exportType: PropTypes.oneOf([EXPORT_ALL, EXPORT_SELECTED]).isRequired,
  setExportType: PropTypes.func.isRequired,
};

export default ExportTypeSelector;
